import Api from "@/config/Api";

export default {
  login(data) {
    return Api().post("/login", data);
  },

  register(data) {
    return Api().post("/register", data);
  },

  profileUpdate(data) {
    return Api().post("/me", data);
  },

  passwordChange(data) {
    return Api().post("/me/password", data);
  },

  passwordRecovery(data) {
    return Api().post("/password/reset", data);
  },

  passwordRecoveryFind(token) {
    return Api().get(`/password/reset/${token}`, {});
  },

  passwordRecoveryReset(data) {
    return Api().post("/password/change", data);
  },

  validateEmailExist(data) {
    return Api().post("/register/email", data);
  },

  getProfile() {
    return Api().get("/me");
  },

  updatedUserConfigGeneral(data) {
    return Api().post("/me/config/general", data);
  },

  // Onboarding
  updateOnboardingBusiness(data) {
    return Api().put("/onboarding/business", data);
  },

  updateOnboardingContact(data) {
    return Api().put("/onboarding/contact", data);
  },

  updateOnboardingBranding(data) {
    return Api().put("/onboarding/branding", data, {
      skipErrorNotification: true
    });
  },

  completeOnboarding() {
    return Api().post(
      "/onboarding/complete",
      {},
      { skipErrorNotification: true }
    );
  },

  // Legal Texts
  getLegalText(slug) {
    return Api().get(`/legal-texts/${slug}`);
  },

  getLoginContext() {
    return Api().get("/me/notifications/login-context");
  },

  // Admin impersonation — redeem single-use token
  redeemImpersonation(token) {
    return Api().post(`/auth/impersonate/${token}`);
  }
};
